import CommercialCondition from './CommercialCondition';

export default CommercialCondition;
